import { Device, DeviceSection } from './models';
import { getDeviceDisclaimers } from 'packages/smart-home-support/utils';

const tvIcon = require('../homepage/resources/SHSProdIcons__TV_with_Remote.svg');
const gameIcon = require('../homepage/resources/SHSProdIcons_Game.svg');
const gameSystemIcon = require('../homepage/resources/SHSProdIcons_GameSystem.svg');
const printerIcon = require('../homepage/resources/SHSProdIcons_Printer.svg');
const dvdIcon = require('../homepage/resources/SHSProdIcons_DVD_Player.svg');
const smartLightIcon = require('../homepage/resources/SHSProdIcons_Smart_Lights.svg');
const nestThermIcon = require('../homepage/resources/SHSProdIcons_Nest_Therm.svg');
const laptopIcon = require('../homepage/resources/SHSProdIcons_Laptop.svg');
const doorbellIcon = require('../homepage/resources/SHSProdIcons_Ring_Doorbell.svg');
const mouseIcon = require('../homepage/resources/SHSProdIcons_Mouse.svg');
const watchIcon = require('../homepage/resources/SHSProdIcons_Smartwatch.svg');
const lockIcon = require('../homepage/resources/SHSProdIcons_Smart_Lock.svg');
const routerIcon = require('../homepage/resources/SHSProdIcons_Router.svg');
const tabletIcon = require('../homepage/resources/SHSProdIcons_Tablet.svg');
const headphonesIcon = require('../homepage/resources/SHSProdIcons_Headphones.svg');
const fitnessWatchIcon = require('../homepage/resources/SHSProdIcons__Fitness_Watch.svg');
const monitorIcon = require('../homepage/resources/SHSProdIcons_Monitor.svg');
const kindleIcon = require('../homepage/resources/SHSProdIcons_Kindle.svg');
const keyboardIcon = require('../homepage/resources/SHSProdIcons_Keyboard.svg');
const subAmpIcon = require('../homepage/resources/SHSProdIcons_Sub_Amp.svg');
const streamingDevicesIcon = require('../homepage/resources/SHSProdIcons_Streaming_Devices.svg');
const pillSpeakerIcon = require('../homepage/resources/SHSProdIcons_Pill_Speaker.svg');
const soundBarIcon = require('../homepage/resources/SHSProdIcons_Sound_Bar.svg');
const desktopComputerIcon = require('../homepage/resources/SHSProdIcons_Desktop_Computer.svg');
const hardDriveIcon = require('../homepage/resources/SHSProdIcons_Harddrive.svg');
const smartSpeakersIcon = require('../homepage/resources/SHSProdIcons_Smart_Speakers.svg');
const smartDetectorsIcon = require('../homepage/resources/SHSProdIcons_Smart_Detectors.svg');
const smartCamerasIcon = require('../homepage/resources/SHSProdIcons_Smart_Cameras.svg');

const DETAILS_DEAULT = 'Any make or model of the following';
const disclaimers = getDeviceDisclaimers();

const DEVICES_HOME: Device[] = [
  {
    label: 'TVs',
    icon: tvIcon,
  },
  {
    label: 'Gaming Systems',
    icon: gameSystemIcon,
  },
  {
    label: 'Gaming Remotes',
    icon: gameIcon,
  },
  {
    label: 'Premium Headphones',
    icon: headphonesIcon,
  },
  {
    label: 'DVD and Blu-Ray Players',
    icon: dvdIcon,
  },
  {
    label: 'Subwoofers, Amplifiers, and Tuners',
    icon: subAmpIcon,
  },
  {
    label: 'Streaming Devices',
    finePrint: disclaimers['streaming'],
    icon: streamingDevicesIcon,
  },
  {
    label: 'Speakers',
    icon: pillSpeakerIcon,
  },
  {
    label: 'Sound Bars',
    icon: soundBarIcon,
  },
];

const DEVICES_OFFICE: Device[] = [
  {
    label: 'Desktop Computers',
    finePrint: 'OS restrictions*',
    icon: desktopComputerIcon,
  },
  {
    label: 'Laptops',
    finePrint: 'OS restrictions*',
    icon: laptopIcon,
  },
  {
    label: 'Tablets',
    icon: tabletIcon,
  },
  {
    label: 'E-Reader Tablets',
    icon: kindleIcon,
  },
  {
    label: 'External Monitors',
    icon: monitorIcon,
  },
  {
    label: 'Printers',
    icon: printerIcon,
  },
  {
    label: 'External Hard Drives',
    icon: hardDriveIcon,
  },
  {
    label: 'Routers and Modems',
    finePrint: disclaimers['router'],
    icon: routerIcon,
  },
  {
    label: 'Mouse',
    icon: mouseIcon,
  },
  {
    label: 'Keyboards',
    icon: keyboardIcon,
  },
];

const DEVICES_SMART_WEARABLE: Device[] = [
  {
    label: 'Smart Speakers',
    icon: smartSpeakersIcon,
  },
  {
    label: 'Smart Thermostats',
    icon: nestThermIcon,
  },
  {
    label: 'Smart Smoke & Carbon Monoxide Detectors',
    icon: smartDetectorsIcon,
  },
  {
    label: 'Smart Door Locks',
    icon: lockIcon,
  },
  {
    label: 'Smart Video Doorbells',
    icon: doorbellIcon,
  },
  {
    label: 'Smart Light Dimmers',
    icon: smartLightIcon,
  },
  {
    label: 'Smart Home Security Cameras',
    icon: smartCamerasIcon,
  },
  {
    label: 'Smart Watches',
    icon: watchIcon,
  },
  {
    label: 'Health & Fitness Bands',
    icon: fitnessWatchIcon,
  },
];

export const sections: DeviceSection[] = [
  {
    title: 'home entertainment',
    details: DETAILS_DEAULT,
    devices: DEVICES_HOME,
  },
  {
    title: 'office products',
    details: DETAILS_DEAULT,
    devices: DEVICES_OFFICE,
  },
  {
    title: 'smart products & wearables',
    details: DETAILS_DEAULT,
    devices: DEVICES_SMART_WEARABLE,
  },
];


// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/whats-covered/data.ts